/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PollParticipateMutationVariables = {|
  answerId: string,
  pollId: string,
|};
export type PollParticipateMutationResponse = {|
  +pollParticipate: ?{|
    +participation: ?{|
      +id: string
    |},
    +message: ?string,
  |}
|};
export type PollParticipateMutation = {|
  variables: PollParticipateMutationVariables,
  response: PollParticipateMutationResponse,
|};
*/


/*
mutation PollParticipateMutation(
  $answerId: ID!
  $pollId: ID!
) {
  pollParticipate(pollId: $pollId, answerId: $answerId) {
    participation {
      id
    }
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "answerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pollId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "answerId",
        "variableName": "answerId"
      },
      {
        "kind": "Variable",
        "name": "pollId",
        "variableName": "pollId"
      }
    ],
    "concreteType": "UserPollParticipation",
    "kind": "LinkedField",
    "name": "pollParticipate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PollParticipationNode",
        "kind": "LinkedField",
        "name": "participation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PollParticipateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PollParticipateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2ba5cac5504a146dfc686b2274e941f2",
    "id": null,
    "metadata": {},
    "name": "PollParticipateMutation",
    "operationKind": "mutation",
    "text": "mutation PollParticipateMutation(\n  $answerId: ID!\n  $pollId: ID!\n) {\n  pollParticipate(pollId: $pollId, answerId: $answerId) {\n    participation {\n      id\n    }\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9522d59a5fb85e66b4d30e006267cd69';

module.exports = node;
